import React, { useEffect, useState } from "react";
import Media from "@qlik/qlik/src/components/Media";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import {
    filterValidCta,
    getCardEyebrowText,
    getCardMedia,
    getResourceInternalLinkCta,
    renderSanitizedHtmlContent,
} from "@qlik/qlik/src/lib/util/helpers";
import { formatDate } from "@qlik/qlik/src/lib/util/dates";
import { TYPE_RESOURCE, TYPE_NEWS } from "@qlik/qlik/src/lib/constants/contentful-types";
import * as styles from "./styles.module.css";
import { useI18n } from "@qlik/utils/i18nContext";

const DeckImageCardWide = ({ data }) => {
    const { additionalConfiguration, cardItem, customId } = data ?? {};
    const { title, cta, dateTime, __typename } = cardItem ?? {};
    const cardMedia = getCardMedia(data.cardItem);
    const cardEyebrowText = getCardEyebrowText(data.cardItem);
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");
    let ctaList = filterValidCta(cta);

    // add redirect CTA for resource card
    if (cardItem?.__typename === TYPE_RESOURCE) {
        ctaList = getResourceInternalLinkCta(cardItem, ctaList);
    }
    if (cardItem?.__typename === TYPE_NEWS) {
        if (Array.isArray(ctaList) && ctaList.length > 0) {
            ctaList = ctaList.slice(0, 1);
        }
    }

    const [dateTimeLocalized, setDateTimeLocalized] = useState("");

    // Get the i18n information for formatting dates
    const { i18n } = useI18n();

    useEffect(() => {
        const output = formatDate(dateTime, i18n.curr.langCode);
        setDateTimeLocalized(output);
    }, [dateTime]);

    return (
        <section className={`${sectionPaddingClassName}`} id={customId}>
            <div className="container">
                {ctaList && ctaList.length > 0 && (
                    <div className="flex flex-wrap gap-3.75 mt-5 lg:mt-auto ">
                        {ctaList.map((linkData) => (
                            <Cta
                                key={linkData.id}
                                className="leading-none pr-0 after:hidden w-full p-0 bg-white hover:bg-white text-left border-none"
                                data={linkData}
                            >
                                <div className="group border border-stone/50 bg-white rounded p-3 md:p-5 hover:no-underline group/resource-card lg:hover:shadow-lg transition-shadow duration-300">
                                    <div className="row">
                                        <div className="md:col-6 md:pr-0">
                                            <div className={`overflow-hidden h-full ${styles.cardMedia}`}>
                                                {cardMedia && (
                                                    <Media
                                                        media={cardMedia}
                                                        className="group-hover:scale-105 transition-all duration-300 w-full lg:max-h-[273px]"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="md:col-6 flex flex-col md:px-10 px-6 pt-5">
                                            {/* hide datetime for resources */}
                                            {dateTime && __typename !== TYPE_RESOURCE && (
                                                <span className="tag-2 text-gray/50 uppercase mb-2.5">
                                                    {dateTimeLocalized}
                                                </span>
                                            )}
                                            {cardEyebrowText && (
                                                <p className="tag-2 uppercase text-sm mt-5 mb-3">{cardEyebrowText}</p>
                                            )}
                                            {title && (
                                                <h2
                                                    className={`${styles.cardTitles} title-3 text-gray line-clamp-3`}
                                                    // eslint-disable-next-line react/no-danger
                                                    dangerouslySetInnerHTML={{
                                                        __html: renderSanitizedHtmlContent(title),
                                                    }}
                                                />
                                            )}
                                            <div className="flex flex-wrap gap-3.75 mt-5 lg:mt-auto ">
                                                <span
                                                    key={linkData.id}
                                                    className={`py-4 leading-none ${
                                                        linkData?.type === "Green Link"
                                                            ? "green-link lg:group-hover/resource-card:text-dark-green lg:group-hover/resource-card:after:arrow-green-dark lg:group-hover/resource-card:after:translate-x-0.75"
                                                            : ""
                                                    } ${
                                                        linkData?.type === "Primary Large"
                                                            ? "lg:group-hover/resource-card:bg-dark-green lg:group-hover/resource-card:border-dark-green"
                                                            : ""
                                                    }`}
                                                >
                                                    {linkData.text}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Cta>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default DeckImageCardWide;
